import i18n from '@/i18n'
import _ from 'lodash'

function invokeValidateCallback (error, callback) {
  if (callback) {
    if (error) {
      callback(new Error(error))
    } else {
      callback()
    }
  } else {
    return error
  }
}

export const emailRegexp = /(^[-!#$%&'*+/=?^_`{}|~0-9A-Z]+(\.[-!#$%&'*+/=?^_`{}|~0-9A-Z]+)*|^"([\001-\010\013\014\016-\037!#-[]-\177]|\\[\001-\011\013\014\016-\177])*")@((?:[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?\.)+[A-Z]{2,6}\.?$)|\[(25[0-5]|2[0-4]\d|[0-1]?\d?\d)(\.(25[0-5]|2[0-4]\d|[0-1]?\d?\d)){3}\]$/i
export function validateEmail (rule, value, callback) {
  let error
  if (!value || !emailRegexp.test(value)) {
    error = i18n.t('common.message.invalidEmail')
  }
  return invokeValidateCallback(error, callback)
}

export function validateEmailByVant (value) {
  if (!value || !emailRegexp.test(value)) {
    return i18n.t('common.message.invalidEmail')
  }
}

export function validatePhoneByRegexpList (rule, value, callback) {
  let error
  if (value && /[\s]+/.test(value)) {
    error = i18n.t('common.message.mobileOnlySupport')
    return invokeValidateCallback(error, callback)
  }
  if (!value || !/^[\d+-\\*/()]+$/.test(value)) {
    error = i18n.t('common.message.invalidMobile')
  }
  return invokeValidateCallback(error, callback)
}

export function validatePhoneByRegexpListByVant (value) {
  if (value && /[\s]+/.test(value)) {
    return i18n.t('common.message.mobileOnlySupport')
  }
  if (!value || !/^[\d+-\\*/()]+$/.test(value)) {
    return i18n.t('common.message.invalidMobile')
  }
}

export function validatePhone (rule, value, callback) {
  let error
  if (value && /^(\+)*(0)*(86)*1(\d){10}$/.test(value)) {

  } else {
    error = i18n.t('common.message.invalidMobile')
  }
  return invokeValidateCallback(error, callback)
}

export function validatePhoneByVant (value) {
  if (value && /^(\+)*(0)*(86)*1(\d){10}$/.test(value)) {

  } else {
    return i18n.t('common.message.invalidMobile')
  }
}

export function validatePolicy (rule, value, callback) {
  if (value) {
    callback()
  } else {
    callback(new Error(i18n.t('common.message.needAgreePolicy')))
  }
}

export const passwordRegexp = /^(?![0-9_#@.-]+$)(?![a-zA-Z_#@.-]+$)(?![0-9a-z_#@.-]+$)(?![0-9A-Z_#@.-]+$)[0-9a-zA-Z_#@.-]{10,}$/

export function validatePassword (rule, value, callback) {
  let error
  if (!value || !passwordRegexp.test(value)) {
    error = i18n.t('common.message.invalidPwd')
  }
  return invokeValidateCallback(error, callback)
}

export function validateIDCardNumber (rule, value, callback) {
  // [reduce(lambda x, y: x + y, map(lambda x: int(x[0]) * x[1], zip(id_number[0:17], ) )) % 11]
  if (!value) {
    callback()
    return
  }
  if (value.length !== 18) {
    callback(i18n.t('common.message.invalidIDCardNumber'))
    return
  }
  const seq = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 0]
  const validateStr = '10X98765432'
  const validateIndex = _.chain(value).map((item, index) => parseInt(item.toUpperCase() === 'X' ? 10 : item) * seq[index]).sum().value() % 11
  const checkBit = value[17]
  if (validateStr[validateIndex] === checkBit) {
    callback()
  } else {
    callback(i18n.t('common.message.invalidIDCardNumber'))
  }
}

export function validateIDCardNumberByVant (value) {
  // [reduce(lambda x, y: x + y, map(lambda x: int(x[0]) * x[1], zip(id_number[0:17], ) )) % 11]
  const result = {
    msg: null,
    valid: false
  }
  if (!value) {
    return result
  }
  if (value.length !== 18) {
    result.msg = i18n.t('common.message.invalidIDCardNumber')
    return result
  }
  const seq = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 0]
  const validateStr = '10X98765432'
  const validateIndex = _.chain(value).map((item, index) => parseInt(item.toUpperCase() === 'X' ? 10 : item) * seq[index]).sum().value() % 11
  const checkBit = value[17]
  if (validateStr[validateIndex] === checkBit) {
    result.valid = true
    return result
  } else {
    result.msg = i18n.t('common.message.invalidIDCardNumber')
    return result
  }
}

/**
 * 整数部分最多3位，小数部分最多2位的数字
 * @param {*} rule
 * @param {*} value
 * @param {*} callback
 */
export function validateThreeDigitIntegerTwoDigitDecimal (rule, value, callback) {
  if (value && !/^\d{1,3}(\.\d{1,2})?$/.test(value)) {
    callback(new Error(i18n.t('common.message.invalidNumber')))
  } else {
    callback()
  }
}

export function validateThreeDigitIntegerTwoDigitDecimalForVant (value) {
  const result = {
    msg: null,
    valid: false
  }
  validateThreeDigitIntegerTwoDigitDecimal(null, value, (error) => {
    if (error) {
      result.msg = i18n.t('common.message.invalidNumber')
      result.valid = false
    } else {
      result.valid = true
    }
  })
  return result
}
